<template>
  <div class="relative follow-item">
    <img src="~@/assets/img/follow.png" alt="" />
<!--    <div class="follow-close" @click="onClose">-->
<!--      <van-icon name="cross" size="24px"  @click.native.stop="onClose"/>-->
<!--    </div>-->

    <div class="absolute inset-0 overlay-content">
      <div @click.stop>
        <slot></slot>
      </div>
<!--      <div class="follow-footer">-->
<!--        滑动切换-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'FollowItem',
  methods: {
    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">


.overlay-content {
  padding: 0 10%;
  position: absolute;
  @apply inset-0;
  top: 20%;
}

.follow-footer {
  @apply text-center text-theme-black-650 absolute left-0 right-0;
  bottom: 20px;

  animation: dy-theme-linear 2s infinite alternate;
}
</style>